"use strict";

exports.__esModule = true;

exports["default"] = function (hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-json-tree/lib/utils/hexToRgb.js
 ** module id = 694
 ** module chunks = 0
 **/